import React, { createContext, useState } from 'react';

export const TableContext = createContext();

export const TableProvider = ({ children }) => {
  const [tableData, setTableData] = useState({ data: [], columns: [] });

  return (
    <TableContext.Provider value={{ tableData, setTableData }}>
      {children}
    </TableContext.Provider>
  );
};
